// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ea1f7190","156":"ecb25904","164":"8daeeee0","167":"ab04c285","245":"be088b6b","306":"a4e346a0","328":"baddcf58","442":"ecb51545","461":"9fa8df4c","503":"1fb238c8","696":"a63a3381","697":"8271bf7a","760":"a1ce2f04","872":"09f094b8"}[chunkId] + ".chunk.js";
};